export enum ProductTourStopReasonType {
  Skipped = 'skipped',
  Dismissed = 'dismissed',
  Completed = 'completed',
  RouteChanged = 'routeChanged',
  NoAnchors = 'noAnchors',
}
